export default "__VITE_ASSET__BE$kzHmq__"